import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, makeStyles, Paper, TextField } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addRole, addRoleList, getRoleList, removeRole, updateRole } from "redux/modules/roleSlice";
import store from "redux/store";
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpButton: {
    marginTop: 30,
    textAlign: 'right'
  },
  buttonSave: {
    marginLeft: 5,
    width: 120
  },
  warpRole: {

  },
  listItem: {
    border: '1px solid lightgray'
  },
  warpDialog: {

    padding: "30px", minWidth: "350px", minHeight: "200px"
  },
  warpButtonDialogSave: {
    display: 'flex'
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  textDialog: {
    width: '100%',
  }
}));

function ConfigDialog(props) {
  const classes = useStyles();
  const { onClose, selectedValue, open } = props;


  const [roleName, setRoleName] = useState();

  useEffect(() => {
    setRoleName(selectedValue.roleName);
  }, [selectedValue]);

  const handleListItemClick = () => {
    onClose({ ...selectedValue, roleName: roleName });
  };

  const handleClose = () => {
    onClose();
  };

  const handleInputChange = (e) => {
    setRoleName(e.target.value);
  }

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} maxWidth="xs" className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title">Name</DialogTitle>
      <DialogContent>
        <div>
          <TextField value={roleName} variant="outlined"
            className={classes.textDialog}
            onChange={handleInputChange}
          />

        </div>
        <div className={classes.warpButtonDialogSave}>
          <Button variant="outlined" size="medium" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
            Close
          </Button>
          <Button variant="contained" size="medium" color="primary" onClick={() => handleListItemClick()} className={classes.buttonDialogSave}>
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

// ConfigDialog.propTypes = {
//     onClose: PropTypes.func.isRequired,
//     open: PropTypes.bool.isRequired,
//     // selectedValue: PropTypes.isRequired,
// };


function RolePage() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState('');
  const { list, isLoading } = useSelector((state) => state.role);
  const [open, setOpen] = React.useState(false);


  useEffect(() => {
    dispatch(getRoleList());
  }, []);

  const handleClickOpen = (value) => {
    setSelectedValue(value);
    setOpen(true);
  };

  const defaultRole = {
    roleId: "",
    roleLevel: 0,
    roleName: "",
    status: "Y",
  }

  const HandleSave = async () => {
    // const roleList = useSelector((state) => state.role.list);
    const roleList = store.getState().role.list;

    const body = roleList.map((x, index) => {
      return {
        role: x.roleId,
        roleName: x.roleName,
        roleSta: x.status,
        levels: index + 1
      }
    })

    await dispatch(addRoleList(body));
    await dispatch(getRoleList());
  }

  const handleRemoveRole = (role, index) => {
    if (!window.confirm('Do you want to remove this role?')) { return; }

    const param = {
      role: role,
      index: index
    };
    dispatch(removeRole(param));
  }

  const handleClose = (role) => {

    setOpen(false);
    if (role) {
      if (role && role.roleId) {
        dispatch(updateRole(role));

      }
      else {
        dispatch(addRole(role));
      }

    }
  };

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="Role Level" />
      <ConfigDialog selectedValue={selectedValue} open={open} onClose={handleClose} />
      <div className={classes.warpButton}>
        <Button variant="outlined" size="medium" color="primary" className={classes.buttonSave} onClick={() => handleClickOpen(defaultRole)}>
          Add
        </Button>
        <Button variant="contained" size="medium" color="primary" className={classes.buttonSave} onClick={HandleSave}>
          Save
        </Button>
      </div>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <List>
            {
              list.filter(x => x.status === 'Y').map((row, index) => (
                <ListItem key={index} className={classes.listItem}>
                  <ListItemText
                    primary={row.roleName}
                  />
                  <ListItemSecondaryAction>
                    <IconButton size="medium" edge="end" aria-label="edit" onClick={() => handleClickOpen(row)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton size="medium" edge="end" aria-label="delete" onClick={() => handleRemoveRole(row, index)}>
                      <DeleteIcon color="error" />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>

              ))
            }
          </List>
        </Grid>
      </Grid>
    </Paper >
  );
}

export default RolePage;


